/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * BFF API
 * OpenAPI spec version: 1.0
 */

/**
 * What was done.
 */
export type VehicleAuditEventDtoAction = typeof VehicleAuditEventDtoAction[keyof typeof VehicleAuditEventDtoAction];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VehicleAuditEventDtoAction = {
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
} as const;
